import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusZone } from "azure-devops-ui/FocusZone";
import { Portal } from "azure-devops-ui/Portal";
import { KeyCode } from "azure-devops-ui/Util";

interface IPortalExampleState {
    isPortalOpen: boolean;
}

export default class PortalExample extends React.Component<{}, IPortalExampleState> {
    private portalTop: number;
    private portalLeft: number;
    private openPortalButton = React.createRef<Button>();

    public constructor(props: {}) {
        super(props);
        this.state = { isPortalOpen: false };
    }

    public componentDidMount() {
        window.addEventListener("click", this.onWindowClick);
    }

    public componentWillUnmount() {
        window.removeEventListener("click", this.onWindowClick);
    }

    public render(): JSX.Element {
        return (
            <div ref={element => this.setPosition(element)} onKeyDown={this.onKeyDown}>
                <Button
                    ref={this.openPortalButton}
                    text="Open Portal"
                    onClick={event => {
                        this.setState({ isPortalOpen: true });
                        event.stopPropagation();
                    }}
                />
                {this.state.isPortalOpen && (
                    <Portal>
                        <div
                            className="no-outline component-example-surface"
                            role="dialog"
                            style={{
                                height: "200px",
                                width: "200px",
                                position: "absolute",
                                left: this.portalLeft || "310px",
                                top: this.portalTop || "300px",
                                zIndex: 2,
                                boxShadow: "0 3.2px 7.2px 0 rgba(0, 0, 0, .132)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            tabIndex={-1}
                        >
                            <FocusZone circularNavigation={true} handleTabKey={true} focusOnMount={true}>
                                <div>
                                    <Button onClick={this.closePanel}>Close portal</Button>
                                </div>
                            </FocusZone>
                        </div>
                    </Portal>
                )}
            </div>
        );
    }

    private closePanel = () => {
        this.setState({ isPortalOpen: false });
        if (this.openPortalButton.current) {
            this.openPortalButton.current.focus();
        }
    }

    private onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (!event.isDefaultPrevented() && event.which === KeyCode.escape) {
            this.closePanel();
            event.preventDefault();
        }
    };

    private setPosition = (element: HTMLElement | null) => {
        if (element) {
            this.portalTop = element.offsetTop + 32;
            this.portalLeft = element.offsetLeft;
        }
    };

    private onWindowClick = () => {
        this.setState({ isPortalOpen: false });
    };
}
